<template>
  <div id="university" v-if="$store.state.loaded" v-cloak>
    <!-- <link rel="icon" type="image/png" :href="favicon"> -->

    <!-- Load in stylesheets -->
    <link rel="stylesheet" property="stylesheet" :href="stylesheet">

    <!-- Nav: Hidden by default -->
    <!-- <transition name="nav">
      <nav v-if="showNav" @click.prevent.stop="" class="ds-main ds-background">
        <router-link :to="{name: 'nameSearch'}" class="ds-main ds-color-hover search-link" @click.native="closeNav">Search by keyword</router-link>
        <router-link :to="{name: 'interestSearch'}" class="ds-main ds-color-hover search-link" @click.native="closeNav">Search by interest</router-link>
      </nav>
    </transition> -->

    <!-- <div class="unm-header">
        <unm-header></unm-header>
      </div> -->

    <!-- Header Bar - fixed to top -->

    <header v-if="!$store.getters.isUnmMain" class="ds-main" :class="{'ds-background': !homeRoute, 'home': homeRoute}">
      <div id="header-wraper">
        <router-link class = 'header-img' :to="{name: 'landing'}">
          <img :src="logo">
        </router-link>

        <!-- <span @click.prevent.stop="toggleNav">
          <i class="open-menu fas fa-bars" ></i>
        </span> -->


        <div id="menu-items">
          <div
            id="search-menu"
            class="menu-trigger menu-item"
            :class="{focused: searchFocused}"
          >
            <i class="fas fa-search" ></i>
            <form @submit.prevent="search">
              <input
                type="text"
                @focus="searchFocused = true"
                @blur="searchFocused = false"
                v-model="searchKey"
                placeholder = "Search or jump to..."
              >
            </form>

            <transition name="menu-dropdown">
              <ul class="menu-dropdown ds-main ds-background" v-if="searchFocused">
                <li v-if="$route.name !== 'nameSearch'">
                  <router-link :to="{name: 'nameSearch'}" @click.native="closeNav">All Programs</router-link>
                </li>
                <li v-if="$route.name !== 'interestSearch'">
                  <router-link :to="{name: 'interestSearch'}" @click.native="closeNav">Interest Areas</router-link>
                </li>
              </ul>
            </transition>
          </div>
          <!-- <div
            class="menu-trigger menu-item menu-button"
            :class="{focused: searchFocused}"
          >
            <i class="fas fa-bars"></i>

            <transition name="menu-dropdown">
              <ul class="menu-dropdown ds-main ds-background" v-if="searchFocused">
                <li v-if="$route.name !== 'nameSearch'">
                  <router-link :to="{name: 'nameSearch'}" @click.native="closeNav">All Programs</router-link>
                </li>
                <li v-if="$route.name !== 'interestSearch'">
                  <router-link :to="{name: 'interestSearch'}" @click.native="closeNav">Interest Areas</router-link>
                </li>
              </ul>
            </transition>
          </div> -->
          <div
            id="program-level-menu"
            class="menu-trigger menu-item"
            :class="{selected: showProgramLevelDropdown}"
            v-if="showProgramLevelMenu"
          >
            <div
              class="menu-button"
              @click.prevent.stop="showProgramLevelDropdown = !showProgramLevelDropdown"
            >
              {{ selectedProgramLevel }} <i class="fas fa-chevron-down"></i>
            </div>

            <transition name="menu-dropdown">
              <ul class="menu-dropdown ds-main ds-background" v-if="showProgramLevelDropdown">
                <li v-for="level in programLevels" :key="level">
                  <a @click="selectedProgramLevel = level">{{ level }}</a>
                </li>
              </ul>
            </transition>
          </div>
        </div>
      </div>
    </header>

    <div class="unm-header" v-else>
      <div class="navbar navbar-unm">
        <div class="container">
          <!-- <a class="navbar-brand" href="/landing">
            The University of New Mexico
          </a> -->
          <router-link class = 'navbar-brand' :to="{name: 'landing'}">
            The University of New Mexico
          </router-link>

          <ul class="nav navbar-nav navbar-right hidden-xs" id="toolbar-nav">
            <li><a href="https://directory.unm.edu/departments/" title="UNM A to Z">UNM A-Z</a></li>
            <li><a href="https://my.unm.edu" title="myUNM">myUNM</a></li>
            <li><a href="https://directory.unm.edu" title="Directory">Directory</a></li>
          </ul>
        </div>
      </div>

      <div aria-label="department logo block" id="header" role="banner">
        <div class="container">
          <div
            id="search-menu"
            class="menu-trigger menu-item"
            :class="{focused: searchFocused}"
          >
            <i class="fas fa-search" ></i>
            <form @submit.prevent="search">
              <input
                type="text"
                @focus="searchFocused = true"
                @blur="searchFocused = false"
                v-model="searchKey"
                placeholder = "Search Degrees"
              >
            </form>

            <transition name="menu-dropdown">
              <ul class="menu-dropdown ds-main ds-background" v-if="searchFocused">
                <li v-if="$route.name !== 'nameSearch'">
                  <router-link :to="{name: 'nameSearch'}" @click.native="closeNav">All Programs</router-link>
                </li>
                <li v-if="$route.name !== 'interestSearch'">
                  <router-link :to="{name: 'interestSearch'}" @click.native="closeNav">Interest Areas</router-link>
                </li>
              </ul>
            </transition>
          </div>
          <nav aria-label="Secondary Navigation" class="navbar-collapse collapse" id="top-nav">
            <ul class="nav navbar-nav navbar-right" role="menubar">
              <li><a class="header-link" href="https://students.unm.edu/navigating-your-major/index.html">Advisement</a></li>
              <li><a class="header-link" href="https://studenthub.unm.edu">Student Hub</a></li>
              <li><a class="header-link" href="https://catalog.unm.edu">Catalog</a></li>
              <li><a class="header-link" href="https://schedule.unm.edu">Course Schedules</a></li>
            </ul>
          </nav>
        </div>
      </div>
    </div>

  <!-- https://students.unm.edu/navigating-your-major/index.html
  https://loboachieve.unm.edu/welcome
  https://schedule.unm.edu
  https://catalog.unm.edu/catalogs/2023-2024/#/home -->


    <!-- Router View -->
    <transition name="router" mode="out-in">
      <router-view></router-view>
    </transition>

    <div class="unm-footer">
      <unm-footer></unm-footer>
    </div>
  </div>
</template>

<script>
  import { uniq } from 'lodash'
  import UnmFooter from '../components/unm_footer.vue'
  import UnmHeader from '../components/unm_header.vue'

  export default {
    name: 'University',

    components: {
      UnmFooter,
      UnmHeader
    },

    data() {
      return {
        // showNav: false,
        searchFocused: false,
        showSearchDropdown: false,
        showProgramLevelDropdown: false,
        // selectedProgramLevel: 'Bachelor\'s',
        searchKey: ''
      }
    },

    mounted() {
      this.setUniversity()
      this.setLayouts()
      this.setPeriods()
      document.body.addEventListener('click', () => {
        // this.showNav = false
        this.showProgramLevelDropdown = false
      })
    },

    watch: {
      showNav(bool) {
        document.body[bool ? 'addEventListener' : 'removeEventListener']('click', this.toggleNav)
      },

      $route() {
        this.showSearchDropdown = this.showProgramLevelDropdown = false
      }
    },

    beforeRouteEnter(to, from, next) {
      // console.log('University Enter')
      next()
    },

    beforeRouteUpdate(to, from, next) {
      // console.log('University Update')
      next()
    },

    computed: {
      // Returns the url to the university's stylesheet
      stylesheet() {
        return this.$store.state.university.styles_url
      },

      // Returns a url to the university's logo
      logo() {
        return this.$store.state.university.logo_url
      },

      // // Returns a url to the university's favicon
      // favicon() {
      //   return this.$store.state.university.favicon_url
      // },

      // Checks if currently on the landing route
      homeRoute() {
        return this.$route.name == 'landing'
      },

      // University ID
      id() {
        return this.$store.state.id
      },

      showProgramLevelMenu() {
        return ['nameSearch', 'interestSearch'].includes(this.$route.name) && this.programLevels.length > 1
      },

      programLevels() {
        return ['All'].concat(uniq(this.$store.getters.currentMajors.filter(m => m.program_level).map(m => m.program_level.name)))
      },

      selectedProgramLevel: {
        get() {
          return this.$store.state.selectedProgramLevel
        },
        set(pl) {
          this.$store.commit('setSelectedProgramLevel', pl)
        }
      }
    },

    methods: {
      search() {
        this.$router.push({
          name: 'nameSearch',
          query: {keyword: this.searchKey}
        })
        this.searchKey = ''
      },

      // toggleNav() {
      //   this.showNav = !this.showNav
      // },

      // Saves the universities info to the store
      setUniversity() {
        this.$http('universities/' + this.id + '.json')
          .then(response => {
            this.$store.commit('setUniversity', response.data)
          })
          .catch(error => {
            console.log(error)
          })
      },

      // Pulls the university Layouts file
      setLayouts() {
        this.$http('universities/' + this.id + '/university_layouts.json')
          .then(response => {
            this.$store.commit('setLayouts', response.data)
          })
          .catch(error => {
            console.log(error)
          })
      },

      // Pulls the university period joins with degree roadmaps enabled
      setPeriods() {
        this.$http('universities/' + this.id + '/university_period_joins.json')
          .then(response => {
            // only write periods that are published for degree_roadmaps
            const filtered = response.data
              .filter(join => join.has_plan_content && join.degree_roadmaps_available)
              .map(join => join.academic_period)
            this.$store.commit('setPeriods', filtered)
          })
          .catch(error => {
            console.log(error)
          })
      }

      // closeNav() {
      //   this.showNav = false
      // }
    }
  }
</script>



// WEBPACK FOOTER //
// University.vue?090f878e